import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { EmployeeListView } from 'src/sections/employee/view';

export default function EmployeeListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title> Employees</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_EMPLOYEE,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <EmployeeListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
